var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-info-field"},[_c('customer-input',{attrs:{"labelText":_vm.label,"value":_vm.personalInfoField.value,"has-error":!_vm.personalInfoField.isValid,"onInput":_vm.setPersonalInfo,"top-left-label":_vm.errorMessage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adb84518","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/subscription/components/PersonalInfoField.vue
// module id = null
// module chunks = 